module.exports = __webpack_public_path__ + "static/media/wizard-mode-text.383ebe22.png";